import {
  withMiddleware,
  createHttpClient,
} from '@mercadona/mo.library.web-services/http'
import { setDeliveryAreaCookie } from 'utils/cookies'

const API_HOST = process.env.REACT_APP_API_HOST
const APP_VERSION = process.env.REACT_APP_VERSION

const settings = {
  getHeaders: function () {
    return {
      'content-type': 'application/json',
      'x-version': APP_VERSION,
    }
  },
  API_HOST,
}

function hasChangedWarehouse(response) {
  if (!response.headers) {
    return response
  }

  const warehouseInHeader = response.headers.get('x-customer-wh')
  const postalCodeInHeader = response.headers.get('x-customer-pc')

  const deliveryInfo = {
    warehouse: warehouseInHeader,
    postalCode: postalCodeInHeader,
  }

  setDeliveryAreaCookie(deliveryInfo)

  return response
}

const Http = withMiddleware(hasChangedWarehouse)(createHttpClient(settings))

export { Http }
